import { isAuthenticated, hasAccess } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'users',
    path: '/users',
    component: () => LazyLoadView(import(/* webpackChunkName: "users" */ '@/views/User/Users.vue')),
    beforeEnter: hasAccess('admin'),
  },
  {
    name: 'user-create',
    path: '/users/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "user-mutate" */ '@/views/User/Mutate.vue')),
    beforeEnter: hasAccess('admin'),
  },
  {
    name: 'user-edit',
    props: true,
    path: '/users/:id',
    component: () => LazyLoadView(import(/* webpackChunkName: "user-mutate" */ '@/views/User/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
]
